export default {
  edits: `/v1/programs/edit`,
  index_list: `/v1/programs/edit/index_list`,
  index_methodical: `/v1/programs/edit/index_methodical`,
  index_search: `/v1/programs/edit/index_search`,
  edit: (id: string) => `/v1/programs/edit/${id}`,
  shows: `/v1/programs/show`,
  show: (id: string) => `/v1/programs/show/${id}`,
  version: (id: string) => `/v1/programs/versions/${id}`,
  relations: (id: string) => `/v1/programs/edit/${id}/relations`,
  changes_exist: (id: string) => `/v1/programs/versions/${id}/changes_exist`,
  copy: (id: string) => `/v1/programs/edit/${id}/copy`,
  archived: (id: string) => `/v1/programs/edit/${id}/archived`,
  change_author: (id: string) => `/v1/programs/edit/${id}/change_author`,
  available_skills: (factory_id: string) =>
    `/v1/programs/edit/${factory_id}/available_skills`,
  inspectors: `/v1/programs/inspectors`,
  inspector: (id: string) => `/v1/programs/inspectors/${id}`,
  send_to_approval: (id: string) => `/v1/programs/edit/${id}/approval`,
  confirm_approval: (id: string) => `/v1/programs/edit/${id}/confirm`,
  confirm_approval_admin: (id: string) =>
    `/v1/programs/edit/${id}/confirm_admin`,
  agreement: (id: string) => `/v1/programs/agreement/${id}`,
  agreement_history: (id: string) => `/v1/programs/agreement_history/${id}`,
  agreement_delegation: (id: string) =>
    `/v1/programs/agreement/${id}/delegation`,
  assignments: `/v1/programs/assignments`,
  assignment: (id: string) => `/v1/programs/assignments/${id}`,
  assignment_available_programs: `/v1/programs/assignments/available_programs`,
  assignment_available_positions: `/v1/programs/assignments/available_positions`,
  assignment_available_workplaces: `/v1/programs/assignments/available_workplaces`,
  assignment_available_users: `/v1/programs/assignments/available_users`,
  assignment_programs: `/v1/programs/assignments/programs`
};
